import ReactSelect, { Props as SelectProps } from "react-select";

import { ErrorMessage } from "../ErrorMessage";
import { Container } from "./styles";

interface Props extends SelectProps {
  error?: string;
}
const SelectInput = ({ error, options, ...rest }: Props) => {
  return (
    <Container>
      <ReactSelect {...rest} options={options} />
      {error && <ErrorMessage erro={error} />}
    </Container>
  );
};

export { SelectInput };
